// src/components/nodes/CustomNode.js
import { NodeBase } from './NodeBase';

export class CustomNode extends NodeBase {
  constructor() {
    super('custom', { label: '新节点', icon: '📝' });
  }

  renderContent(data, selected) {
    return (
      <div className="node-content">
        {data.icon && <span className="node-icon">{data.icon}</span>}
        <span className="node-label">{data.label}</span>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '流程节点',
      icon: '⬜',
      defaultData: this.defaultData
    };
  }
}